import React from 'react'
import { Provider } from 'react-redux'
import { useSelector } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import Theme from 'components/template/Theme'
import store, { persistor } from './store'
import Layout from 'components/layout'
import CustomIndicator from 'views/ui-components/feedback/Spinner/CustomIndicator'
import history from './history'
// import mockServer from './mock'
// import appConfig from 'configs/app.config'
// import './locales'
// import axiosUtils from 'utils/axios-utils'

// const environment = process.env.NODE_ENV

// if (appConfig.enableMock) {
//     mockServer({ environment })
// }

const GlobalApiLoader = () => {
    const apiPendingRequests = useSelector(
        (state) => state.base.common.apiPendingRequests
    )

    if (!apiPendingRequests) {
        return null
    }

    return (
        <div className="fixed inset-0 z-50 bg-white/60 dark:bg-gray-900/60 flex items-center justify-center">
            <CustomIndicator />
        </div>
    )
}

function App() {
    // useEffect(() => {
    //     axiosUtils.setBaseAPI_URL('https://api.shipcluescargo.com')
    // }, [])

    return (
        <Provider store={store}>
            <PersistGate loading={<CustomIndicator fullscreen />} persistor={persistor}>
                <BrowserRouter history={history}>
                    <Theme>
                        <GlobalApiLoader />
                        <Layout />
                    </Theme>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

export default App
